import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

// pure pipe so markdown is parsed once per message, not on every CD cycle
@Pipe({ name: 'markdownSafe', pure: true })
export class MarkdownSafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    const rawHtml = marked.parse(value || '');
    return this.sanitizer.sanitize(SecurityContext.HTML, rawHtml) || '';
  }
}
